import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";
import { AuthProvider } from "./hooks/AuthContext";
import { getCsrfToken } from "./api";
import { ParallaxProvider } from "react-scroll-parallax";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Fetch the CSRF token before rendering the app
getCsrfToken().then(() => {
  root.render(
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AuthProvider>
        <ParallaxProvider>
          <App />
        </ParallaxProvider>
      </AuthProvider>
    </BrowserRouter>
  );
});
